import { endLoading, startLoading } from '../actions/loadingAction';
import * as actionsPhysicalConfirmation from '../actions/physicalConfirmationAction';
import * as locationAction from '../actions/locationAction';
import { ENUMS } from '../utils/constants';
import { getUrlLocationApi, language, parseParams, showMessageToastCustom, translate } from '../utils/util';
import HttpService from './HttpService';
import * as auth from './auth';

const httpService = new HttpService(getUrlLocationApi(window));

export default class ChangeLocationService {
    static changeLocation(location, callback) {
        const url = '/api/changelocation';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, location).then((response) => {
                if (response.status === 200) {
                    if (!location.twoSteps && response.data?.data) {
                        let i = 1;
                        response.data.data.forEach((data) => {
                            if (+location.amountTag === 0 || i <= +location.amountTag) {
                                this.printLabelLocation(data);
                                i += 1;
                            }
                        })
                    }
                    if (callback) {
                        callback(response.data?.data);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static massiveChangeLocation(massiveLocation, callback) {
        const url = '/api/changelocation/massive';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, massiveLocation).then((response) => {
                if (response.status === 200) {
                    if (response.data.data) {
                        response.data.data.resultChangeLocation.forEach((data) => {
                            if (data.dataToPrint) {
                                this.printLabelLocation(data);
                            }
                        })
                    }
                    if (callback) {
                        callback(response.data?.data?.messages);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static changeLocationList(massiveLocation, callback) {
        const url = '/api/changelocation/list';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, massiveLocation).then((response) => {
                if (response.status === 200) {
                    if (response.data.data) {
                        response.data.data.forEach((data) => {
                            if (data.dataToPrint) {
                                this.printLabelLocation(data);
                            }
                        })
                    }
                    if (callback) {
                        callback(response.data?.data);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static printLabelLocation(data) {
        if (data.printer && data.printer.connectionType === ENUMS.ePrinterConnectionType.Bluetooth.value) {
            if (navigator.userAgent === 'logisticspwa') {
                const sendToPrinter = {
                    messageType: 'printLocation',
                    dataToPrint: data.dataToPrint,
                    printerAddress: data.printer.macAddress,
                    printerManufacturer: data.printer.printerManufacture || ENUMS.ePrinterManufacturerPortable.Honeywell.value,
                    token: auth.getToken(),
                    urlBase: getUrlLocationApi(window) + "/api/changelocation/print/" + data.changeLocation.id,
                    lng: language()
                };
                window.ReactNativeWebView.postMessage(JSON.stringify(sendToPrinter));
            } else {
                showMessageToastCustom(translate('warning', 'general'), 'Impressão não pode ser realizada', 8000, 'mdi mdi-alert-circle-outline red-text');
            }
        }
    }

    static getLabels(filter) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/changelocation`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionsPhysicalConfirmation.updateLabels(response.data.data));
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getCims(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/changelocation/cim`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data && callback) {
                        callback(response.data?.data)
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static reprintLabel(data, callback) {
        const url = '/api/changelocation/reprint';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, data).then((response) => {
                if (response.status === 200) {
                    if (response.data?.data) {
                        this.printLabelLocation(response.data?.data);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
                if (callback) {
                    callback()
                }
            });
        }
    }

    static getAreasConversions(filter, pagination) {
        Object.assign(filter, pagination);
        const url = '/api/areaConversion';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionsPhysicalConfirmation.setAreaConversions(response.data.data));
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static addAreaConversion(dto, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/areaConversion`, dto, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (response.data?.data) {
                            showMessageToastCustom(translate('general.info'), translate('sucess-to-include', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text')
                        }
                        if (callback) callback(response.data?.data)
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static updateAreaConversion(dto, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(`/api/areaConversion`, dto, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data) {
                        if (response.data?.success) {
                            showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text')
                        }
                        if (callback) callback(response.data?.success)
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static updateMassive(dto, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(`/api/transmission/massive`, dto, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data) {
                        if (callback) callback(response.data?.success)
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static deleteAreaConversion(id, callback) {
        if (navigator.onLine) {
            const url = `/api/areaConversion/${id}`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.delete(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        showMessageToastCustom(translate('general.info'), result.data.message, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static uploadFile(data, file, callback) {
        const url = '/api/changelocation/uploadfile';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);
                formData.append('Print', data.print);
                formData.append('Resource', data.resource);
                formData.append('Printer', JSON.stringify(data.printer));

                httpService.instance.post(url, formData).then((response) => {
                    const data = response.data.data;
                    if (data.length > 0) {
                        var dataSuccess = data.filter((f) => f.success && f.data);
                        dataSuccess.forEach(element => {
                            this.printLabelLocation(element.data);
                        });
                    }
                    if (callback) {
                        callback(data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getFileLog(filter, pagination, callback) {
        Object.assign(filter, pagination);
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/filelog`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
        callback();
    }

    static getReportFileLog(filter, callback) {
        const url = '/api/filelog/report';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getTransmissions(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/transmission`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
        callback();
    }

    static getTransmissionsReprocess(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/transmission/reprocess`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
        callback();
    }


    static getInfo(filter, callback) {
        if (navigator.onLine) {
            return () => {
                httpService.instance.get(`/api/transmission/info`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    if (callback) {
                        callback();
                    }
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                });
            };
        }
        callback();
    }

    static getSummaryErrors(filter, callback) {
        if (navigator.onLine) {
            return () => {
                httpService.instance.get(`/api/transmission/summaryerror`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    if (callback) {
                        callback();
                    }
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                });
            };
        }
        callback();
    }

    static getReportTransmission(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                const url = `/api/transmission/report`;
                dispatch(startLoading());
                httpService.instance.get(url,
                    {
                        params: filter
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static deleteTransmission(id, callback) {
        if (navigator.onLine) {
            const url = `/api/transmission/${id}`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.delete(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        showMessageToastCustom(translate('general.info'), result.data.message, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }


    static deleteAllTransmission(filter, callback) {
        if (navigator.onLine) {
            const url = `/api/transmission/all`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, filter, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        showMessageToastCustom(translate('general.info'), result.data.message, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static deleteSelected(ids, callback) {
        if (navigator.onLine) {
            const url = `/api/transmission/selected`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, ids, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        showMessageToastCustom(translate('general.info'), result.data.message, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    if (callback) callback()
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static reprocessTransmission(model, callback) {
        if (navigator.onLine) {
            const url = `/api/transmission/reprocess`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(url, model, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        showMessageToastCustom(translate('general.info'), result.data.message, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static reprocessAllTransmission(filter, callback) {
        if (navigator.onLine) {
            const url = `/api/transmission/reprocess/all`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(url, filter, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        showMessageToastCustom(translate('general.info'), result.data.message, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static reprocessSelected(ids, callback) {
        if (navigator.onLine) {
            const url = `/api/transmission/reprocess/selected`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(url, ids, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (callback) {
                        callback(result.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    if (callback) callback()
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static confirmMasterCim(model, callback, callbackError) {

        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/mastercim`, model, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        var task = response.data?.data?.task;
                        if (response.data?.data) {
                            if (task && callbackError) {
                                return callbackError(response.data?.data?.message, true);
                            }

                            const label = response.data.data;
                            if (label) {
                                this.printLabelLocation([label], model.printer);
                            }
                        }

                        showMessageToastCustom(translate('general.info'), translate('success-master-cim', 'stock'), 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        if (callback) {
                            callback();
                        }
                    }

                }).catch((error) => {
                    if (callbackError) {
                        callbackError(error.response?.data?.message || error.message || error, false);
                    }
                    else {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static confirmationAllocation(location, callback) {
        const url = '/api/confirmationallocation';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, location).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(response.data?.data);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }




    static live(callback) {
        const url = '/api/live';
        return () => {
            if (navigator.onLine) {
                httpService.instance.get(url).then((response) => {
                    callback(response);
                }).catch((error) => {
                    callback(error);
                })
            }
        };
    }

    static setActiveTab(activeTab) {
        return (dispatch) => { dispatch(actionsPhysicalConfirmation.setActiveTab(activeTab)); };
    }

    static setFilter(filter) {
        return (dispatch) => { dispatch(actionsPhysicalConfirmation.setFilter(filter)); };
    }

    static setPrintSelect(printSelect) {
        return (dispatch) => { dispatch(actionsPhysicalConfirmation.setPrintSelect(printSelect)); };
    }

    static clearPrintSelect() {
        return (dispatch) => { dispatch(actionsPhysicalConfirmation.clearPrintSelect()); };
    }

    static setTwoSteps(data) {
        return (dispatch) => { dispatch(locationAction.setTwoSteps(data)); };
    }
}